import { render, staticRenderFns } from "./LabInvoiceAddDetailModal.vue?vue&type=template&id=420ee690&scoped=true&"
import script from "./LabInvoiceAddDetailModal.vue?vue&type=script&lang=js&"
export * from "./LabInvoiceAddDetailModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ee690",
  null
  
)

export default component.exports